function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Context from './AccordionContext';

require('xps-style/core/accordion.css');

var propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,

  /**
   * Pass an array of uuid(s) to set expanded items outside the component
   * For single expanded accordion (allowMultipleExpanded=false), pass the uuid as string
   */
  expanded: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),

  /** Allows more than one item to be expanded at the same time */
  allowMultipleExpanded: PropTypes.bool,

  /** Allows zero items to be expanded at any given time */
  allowZeroExpanded: PropTypes.bool,

  /** A callback invoked when an item has been expanded or collapsed */
  onChange: PropTypes.func
};

var Accordion = function Accordion(_ref) {
  var className = _ref.className,
      children = _ref.children,
      expanded = _ref.expanded,
      _ref$allowMultipleExp = _ref.allowMultipleExpanded,
      allowMultipleExpanded = _ref$allowMultipleExp === void 0 ? true : _ref$allowMultipleExp,
      _ref$allowZeroExpande = _ref.allowZeroExpanded,
      allowZeroExpanded = _ref$allowZeroExpande === void 0 ? true : _ref$allowZeroExpande,
      onChange = _ref.onChange;
  var defaultExpanded = expanded || [];

  var _useState = useState(allowMultipleExpanded ? defaultExpanded : defaultExpanded.slice(0, 1)),
      _useState2 = _slicedToArray(_useState, 2),
      expandedItems = _useState2[0],
      setExpandedItems = _useState2[1];

  var toggleItem = function toggleItem(uuid) {
    if (expandedItems.includes(uuid)) {
      if (allowZeroExpanded || expandedItems.length > 1) {
        // collapse
        var items = expandedItems.filter(function (item) {
          return item !== uuid;
        });
        setExpandedItems(items);
        onChange && onChange(items);
      }
    } else {
      // expand
      var _items = allowMultipleExpanded ? expandedItems.concat([uuid]) : [uuid];

      setExpandedItems(_items);
      onChange && onChange(_items);
    }
  };

  useEffect(function () {
    expanded && setExpandedItems(expanded);
  }, [expanded]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      expandedItems: expandedItems,
      toggleItem: toggleItem
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx('accordion', className)
  }, children));
};

Accordion.propTypes = propTypes;
Accordion.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Accordion",
  "props": {
    "allowMultipleExpanded": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Allows more than one item to be expanded at the same time"
    },
    "allowZeroExpanded": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Allows zero items to be expanded at any given time"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "expanded": {
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Pass an array of uuid(s) to set expanded items outside the component\nFor single expanded accordion (allowMultipleExpanded=false), pass the uuid as string"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A callback invoked when an item has been expanded or collapsed"
    }
  }
};
export default Accordion;